const UNSEATED_GROUP_ID = 'unseated';
const SEATED_TAB = 'seated';
const TABLE_FULL_MESSAGE = 'Table is full';
const SEAT_OCCUPIED_MESSAGE = 'Cannot seat guest at this location';
const NOT_ENOUGH_SEATS_MESSAGE = 'Not enough seats available';
const TICKET_NOT_FOUND_MESSAGE = 'Ticket not found';
const TABLE_NOT_FOUND_MESSAGE = 'Table not found';
const NO_TICKETS_MESSAGE = 'No tickets to reshuffle';
const TICKETS_NOT_FOUND_MESSAGE = 'One or more tickets not found';
const DEFAULT_TABLE_CAPACITY = 4;
const MAX_HISTORY_SIZE = 20;

enum SeatingGroupType {
    TABLE = 'table',
    UNSEATED = 'unseated',
}

enum GROUP_POSITION_VALUES {
    FIRST = 'first',
    MIDDLE = 'middle',
    LAST = 'last',
    SOLO = 'solo',
}

enum DropTarget {
    TICKET = 'ticket',
    EMPTY_SEAT = 'empty-seat',
    OCCUPIED_SEAT = 'occupied-seat',
    SEATING_CONTAINER = 'seating-container',
    UNSEATED_CONTAINER = 'unseated-container',
    TABLE_CONTAINER = 'table-container',
    GROUP_HEADER = 'group-header',
    TABLE_HEADER = 'table-header',
    GROUP = 'group',
    MULTI_SELECTION = 'multi-selection',
}

export {
    UNSEATED_GROUP_ID,
    MAX_HISTORY_SIZE,
    SEATED_TAB,
    TABLE_FULL_MESSAGE,
    SEAT_OCCUPIED_MESSAGE,
    NOT_ENOUGH_SEATS_MESSAGE,
    TICKET_NOT_FOUND_MESSAGE,
    TABLE_NOT_FOUND_MESSAGE,
    NO_TICKETS_MESSAGE,
    TICKETS_NOT_FOUND_MESSAGE,
    DEFAULT_TABLE_CAPACITY,
    SeatingGroupType,
    GROUP_POSITION_VALUES,
    DropTarget,
};
